export type MediaObjectPosition =
  | "left top"
  | "center top"
  | "right top"
  | "left center"
  | "center center"
  | "right center"
  | "left bottom"
  | "center bottom"
  | "right bottom";

export const DEFAULT_MEDIA_OBJECT_POSITION: MediaObjectPosition =
  "center center";

export const mediaObjectPositionOptions: Array<{
  label: string;
  value: MediaObjectPosition;
}> = [
  { label: "Top left", value: "left top" },
  { label: "Top center", value: "center top" },
  { label: "Top right", value: "right top" },
  { label: "Center left", value: "left center" },
  { label: "Center", value: "center center" },
  { label: "Center right", value: "right center" },
  { label: "Bottom left", value: "left bottom" },
  { label: "Bottom center", value: "center bottom" },
  { label: "Bottom right", value: "right bottom" },
];

const mediaObjectPositionValues = new Set<MediaObjectPosition>(
  mediaObjectPositionOptions.map(({ value }) => value),
);

export const isMediaObjectPosition = (
  value: unknown,
): value is MediaObjectPosition =>
  typeof value === "string" &&
  mediaObjectPositionValues.has(value as MediaObjectPosition);

export const resolveMediaObjectPosition = (
  value: unknown,
): MediaObjectPosition =>
  isMediaObjectPosition(value) ? value : DEFAULT_MEDIA_OBJECT_POSITION;

export const mediaObjectPositionClassName = (value: unknown): string => {
  const objectPosition = resolveMediaObjectPosition(value);

  switch (objectPosition) {
    case "left top":
      return "object-left-top";
    case "center top":
      return "object-top";
    case "right top":
      return "object-right-top";
    case "left center":
      return "object-left";
    case "right center":
      return "object-right";
    case "left bottom":
      return "object-left-bottom";
    case "center bottom":
      return "object-bottom";
    case "right bottom":
      return "object-right-bottom";
    case "center center":
    default:
      return "object-center";
  }
};
